module.exports = __webpack_public_path__ + "fonts/iconfont.3eae6cf.ttf";